import {connect} from 'react-redux';
import ButtonDeleteFile from './ButtonDeleteFile';
import {deleteFile} from '../../actions/files/deleteFile';
import {getFileList} from '../../actions/files/getFileList';

export default connect(
  null,
  {deleteFile, getFileList}
)(ButtonDeleteFile);
